import compactBox from './compact-box';
import dendrogram from './dendrogram';
import indented from './indented';
import mindmap from './mindmap';

export { compactBox, dendrogram, indented, mindmap };

export * from './types';

export default {
  compactBox,
  dendrogram,
  indented,
  mindmap,
};

export const version = '0.7.0';
